import React from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from "@material-ui/core/styles";
import { StepsIntl } from './Steps.intl';
import './Steps.scss';
import devicePhoto from '../../static/calibration/calibration-second-step.png';
import { TextField } from '@material-ui/core';
import { NumberFormatCustom } from './stepsHelper';
import { useField } from 'formik';
import { useBem } from '../../Bem';
import { useCurrentMeasurment, steps } from '../helper';

const useStyles = makeStyles(() => ({
  resize: {
    fontSize: 16,
  }
}));

export const Step2 = () => {
  const bem = useBem('step2');
  const intl = useIntl();
  const classes = useStyles();
  const [field, meta, helpers] = useField({ name: 'cameraHeight' });
  const currentMeasurment = useCurrentMeasurment();

  return (
    <div className={bem.elem('container').cls()}>
      <p className={bem.elem('text').cls()}>
        <span>(2/{steps.length})&nbsp;</span>
        <span>{intl.formatMessage(StepsIntl.stepRequirements_2, { value: currentMeasurment.value.toLowerCase() })}</span>
      </p>
      <div className={bem.elem('text-field').cls()}>
        <TextField
          variant="standard"
          style={{width: 125 }}
          type="text"
          name="cameraHeight"
          placeholder={`0 ${currentMeasurment.value.toLowerCase()}`}
          onChange={field.onChange}
          value={field.value}
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
          InputProps={{
            inputComponent: NumberFormatCustom as any,
          }}
        />
      </div>
      <div className={bem.elem('wrapper').cls()}>
        <img className={bem.elem('photo').mods('step2').cls()} src={devicePhoto} />
      </div>
    </div>
  );
};
